import { gql as t } from "@apollo/client";
import { PublicOwnerFragment as n } from "../../auth-lib/graphql/fragment/account.js";
import { PageInfoFragment as e } from "../../common-lib/graphql/fragments/pageInfo.js";
import { PublicInvitationFragment as i } from "../../temp-lib/graphql/fragment/account.js";
const c = t`
  query GetAccountInvitees($input: GetInviteesFilterInput) {
    getAccountInvitees(input: $input) {
      edges {
        account {
          ...PublicOwner
        }
        accountInvitation {
          ...PublicInvitation
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${n}
  ${i}
  ${e}
`;
export {
  c as default
};
//# sourceMappingURL=getAccountInvitees.js.map
